module.exports = __webpack_public_path__ + "img/swap-v-o.798af2eb.svg";